import Image from 'next/image';
import { cn } from '@/lib/utils';

/** Kandy character portrait served from `public/Kandy.jpg`. */
export const SUPER_HELPER_AVATAR_SRC = '/Kandy.jpg';

type SuperHelperAvatarProps = {
  className?: string;
  sizes?: string;
  priority?: boolean;
};

export function SuperHelperAvatar({
  className,
  sizes = '96px',
  priority = false,
}: SuperHelperAvatarProps) {
  return (
    <Image
      src={SUPER_HELPER_AVATAR_SRC}
      alt=""
      width={640}
      height={640}
      sizes={sizes}
      priority={priority}
      unoptimized
      className={cn('object-cover', className)}
    />
  );
}
